export default {"src":"/_next/static/media/alert.486fefd8.svg","height":28,"width":33};